import { t } from "i18next";

export const FIXTURES_TYPE = {
  LIVE: t("fixtureTypeTab.live"),
  UPCOMING: t("fixtureTypeTab.upcoming"),
  PAST: t("fixtureTypeTab.past"),
};
